/**
 * 7. 경쟁사 셀러태그 사용 빈도 카드
 */
import React from 'react';
import { Card, Space, Spin, Button } from 'antd';
import { TagsOutlined, ReloadOutlined } from '@ant-design/icons';

const CompetitorTagsCard = ({ report, tagsState, onRetryTags }) => {
    const myTags = (report.product?.tags || '')
        .split(',')
        .map(t => t.trim().toLowerCase())
        .filter(Boolean);

    const competitors = (report.competitors || []).map(c => {
        const detail = tagsState?.data?.[c.mallUrl];
        return detail?.tags ? { ...c, tags: detail.tags } : c;
    });

    const tagFreq = {};
    competitors.forEach(c => {
        (c.tags || []).forEach(tag => {
            const clean = tag.toLowerCase();
            tagFreq[clean] = (tagFreq[clean] || 0) + 1;
        });
    });
    const sortedTags = Object.entries(tagFreq).sort((a, b) => b[1] - a[1]);

    const tagsLoading = tagsState?.loading;
    const tagsError = tagsState?.error;

    return (
        <Card
            title={
                <span
                    style={{
                        fontSize: 14,
                        fontWeight: 700,
                        color: '#0f172a',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 6,
                    }}
                >
                    <TagsOutlined style={{ color: '#4f46e5' }} /> 경쟁사 셀러태그 사용 빈도
                </span>
            }
            bordered={false}
            className="full-chart-card"
            style={{ marginTop: 24 }}
            extra={
                <Space size={8}>
                    {tagsLoading && <Spin size="small" />}
                    {tagsError && (
                        <Button
                            size="small"
                            icon={<ReloadOutlined />}
                            onClick={onRetryTags}
                            style={{ fontSize: 11, color: '#ef4444', borderColor: '#fca5a5' }}
                        >
                            재조회
                        </Button>
                    )}
                    {!tagsLoading && !tagsError && (
                        <span style={{ fontSize: 14, color: '#64748b' }}>
                            TOP 10 상품 기준 · 전체 {sortedTags.length}개
                        </span>
                    )}
                </Space>
            }
        >
            {tagsLoading ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 120,
                    }}
                >
                    <Spin tip="태그 데이터 수집 중..." />
                </div>
            ) : tagsError ? (
                <div
                    style={{
                        textAlign: 'center',
                        padding: '40px 0',
                        color: '#94a3b8',
                        fontSize: 13,
                    }}
                >
                    태그 데이터를 불러오지 못했습니다.
                </div>
            ) : sortedTags.length === 0 ? (
                <div
                    style={{
                        textAlign: 'center',
                        padding: '40px 0',
                        color: '#94a3b8',
                        fontSize: 13,
                    }}
                >
                    태그 데이터가 없습니다.
                </div>
            ) : (
                <>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 14,
                            maxHeight: 400,
                            overflowY: 'auto',
                            paddingRight: 16,
                        }}
                    >
                        {sortedTags.map(([tag, count], idx) => {
                            const isMyTag = myTags.includes(tag);
                            return (
                                <div
                                    key={idx}
                                    style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                                >
                                    <div
                                        style={{
                                            width: 130,
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: '#475569',
                                            flexShrink: 0,
                                        }}
                                    >
                                        #{tag}{' '}
                                        {isMyTag && (
                                            <span
                                                style={{
                                                    fontSize: 11,
                                                    color: '#fff',
                                                    background: '#4f46e5',
                                                    padding: '2px 8px',
                                                    borderRadius: 4,
                                                    marginLeft: 6,
                                                }}
                                            >
                                                MY
                                            </span>
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            flex: 1,
                                            height: 18,
                                            background: '#f1f5f9',
                                            borderRadius: 9,
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${(count / 10) * 100}%`,
                                                height: '100%',
                                                background: isMyTag ? '#4f46e5' : '#94a3b8',
                                                borderRadius: 9,
                                                transition: 'width 1s ease-out',
                                            }}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            width: 30,
                                            textAlign: 'right',
                                            fontSize: 15,
                                            fontWeight: 800,
                                            color: isMyTag ? '#4f46e5' : '#64748b',
                                        }}
                                    >
                                        {count}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <Space
                        style={{ marginTop: 24, fontSize: 13, color: '#64748b', fontWeight: 500 }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <div
                                style={{
                                    width: 14,
                                    height: 14,
                                    borderRadius: 4,
                                    background: '#4f46e5',
                                }}
                            ></div>{' '}
                            내가 사용 중
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <div
                                style={{
                                    width: 14,
                                    height: 14,
                                    borderRadius: 4,
                                    background: '#94a3b8',
                                }}
                            ></div>{' '}
                            경쟁사만 사용
                        </div>
                    </Space>
                </>
            )}
        </Card>
    );
};

export default CompetitorTagsCard;
